module.exports = __webpack_public_path__ + "img/65.f98f4f04.png";